// همه‌ی منوهایی که سایت در کلاینت می‌گیرد (MenusProvider). جدا از layoutMenus.js که فقط سروری است.
export const LAYOUT_MENU_KEYS = [
  "header-main-menu",
  "category-list",
  "popular_search",
  "header-main-menu-shop",
  "header-main-menu-seller-academy",
  "header-main-menu-ads",
  "product_categories",
  "footer-navigation-mobile",
];

// منوهایی که هدر هر بخش در HTML سرور لازم دارد. فقط همین‌ها در payload صفحه می‌آیند؛
// بقیه مثل قبل بعد از hydration گرفته می‌شوند.
export const server_menu_keys = (pathname = "") => {
  if (pathname.startsWith("/blog")) return ["category-list"];
  return [];
};
